module.exports = __webpack_public_path__ + "img/bg-home-header.6e03d7fb.jpg";